// Session-only product discovery; storage failures never interrupt shopping.
const storageKey = 'ykt-recent-designs';
try {
  let viewed = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
  if (!Array.isArray(viewed)) viewed = [];
  const current = document.querySelector('[data-ykt-current-product]');
  const product = current ? JSON.parse(current.textContent) : null;
  const host = document.querySelector('[data-ykt-recent]');
  const catalog = new Map([...document.querySelectorAll('[data-ykt-recent-card]')].map(el=>[el.dataset.yktRecentCard,el]));
  let shown = 0;
  viewed.filter(id=>id!==product?.handle).slice(0,4).forEach(id=>{
    const card = catalog.get(id); if(card){card.hidden=false;host?.querySelector('.ykt-product-grid')?.append(card);shown++;}
  });
  if(host && shown) host.hidden=false;
  if(product?.handle) sessionStorage.setItem(storageKey,JSON.stringify([product.handle,...viewed.filter(id=>id!==product.handle)].slice(0,4)));
} catch { /* Private browsing may disable storage. */ }
